import {
    DATA_UPDATE_CUSTOMER_SERVICE_ACCOUNT,
    UI_CLOSE_CHAT,
    UI_SCROLL_DOWN_CHAT_LIST,
    UI_SHOW_CHAT,
    UI_TOGGLE_IM,
    UI_SHOW_DIALOG,
    UI_IMG_URL,
    DATA_IS_LOCAL_SESSION,
} from './actionTypes';

export function updateShowChat(showChat) {
    return {
        type: UI_SHOW_CHAT,
        payload: showChat,
    };
}

export function closeChat() {
    return {
        type: UI_CLOSE_CHAT,
        payload: false,
    };
}

export function toggleIM(value) {
    return {
        type: UI_TOGGLE_IM,
        payload: value,
    };
}

export function scrollDownChatListAction() {
    return {
        type: UI_SCROLL_DOWN_CHAT_LIST,
    };
}

export function updateCustomerServiceAccount(accountId) {
    return {
        type: DATA_UPDATE_CUSTOMER_SERVICE_ACCOUNT,
        payload: accountId,
    };
}

export function showDialog(isShown) {
    return {
        type: UI_SHOW_DIALOG,
        payload: isShown,
    };
}

export function setImgUrl(url) {
    return {
        type: UI_IMG_URL,
        payload: url,
    };
}

export function setIsLocalSession(isLocal) {
    return {
        type: DATA_IS_LOCAL_SESSION,
        payload: isLocal,
    };
}
